class Environments {
	static envs = {
		name: '',
		abbreviation: '',
		logo: '',
		logoWhite: '',
		favicon: '',
		cnpj: '',
		legalName: '',
		domain: '',
		customStyle: {
			palette: {
				primary: '',
				secondary: '',
				tertiary: '',
				quaternary: ''
			}
		},
		memedJsUrl: '',
		memedApiUrl: '',
		fbAppId: '',
		fbWabaConfigId: '',
		allow_auto_appointment_whatsapp_confirmation: false,
		allow_appointment_update_whatsapp_confirmation: false,
		portal_url: ''
	};

	static getEnvs() {
		return Environments.envs;
	}

	static setEnvs(envs: typeof Environments.envs) {
		Environments.envs = envs;
	}

	static get isMedClinic() {
		return Environments.platform?.name?.toLowerCase() === 'medclinic';
	}

	static get platform() {
		return Environments.envs;
	}

	static updateAllowAutoAppointmentWhatsappConfirmation(value: boolean) {
		Environments.envs.allow_auto_appointment_whatsapp_confirmation = value;
	}

	static updateAllowAppointmentUpdateWhatsappConfirmation(value: boolean) {
		Environments.envs.allow_appointment_update_whatsapp_confirmation = value;
	}
}

export default Environments;
